<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4 border-bottom">
      <d-col
        col
        sm="4"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Strona główna</span>
        <h3
          style="white-space: nowrap"
          class="page-title">Witaj w CRM - Wędliny z Dębiny</h3>
      </d-col>
    </d-row>
    <d-row class="dashboard">
      <d-col
        lg="3"
        class="dashboard-boxes"
        v-for="(count, index) in statsData.counts"
        :key="index">
        <d-card class="dashboard-box">
          <span>{{count.type === 'TODAY' ? 'Zamówienia na dziś:' : 'Zamówienia na następny dzień roboczy:'}}</span>
          <div class="dashboard-box-absolute">
            <div class="dashboard-box-absolute-box">
              <d-button @click.prevent="openModalList(count.date)">
                Pokaż
              </d-button>
              <h3>{{ count.count }}</h3>
            </div>
          </div>
        </d-card>
      </d-col>
      <d-col
        lg="3"
        class="dashboard-boxes">
        <d-card class="dashboard-box">
          <span>Klienci z zadłużeniem:</span>
          <div class="dashboard-box-absolute">
            <div class="dashboard-box-absolute-box">
              <d-button @click.prevent="openModalCustomersList(customers)">
                Pokaż
              </d-button>
              <h3 v-if="data.stats && data.stats.customers_in_dept">{{ data.stats.customers_in_dept }}</h3>
            </div>
          </div>
        </d-card>
      </d-col>
      <d-col
        lg="3"
        class="dashboard-boxes">
        <d-card class="dashboard-box">
          <span>Oczekujące przelewy:</span>
          <div class="dashboard-box-absolute">
            <div class="dashboard-box-absolute-box">
              <d-button @click.prevent="openModalListWaitingTransfer()">
                Pokaż
              </d-button>
              <h3 v-if="data.stats && data.stats.waiting_transfer">{{data.stats.waiting_transfer}}</h3>
            </div>
          </div>
        </d-card>
      </d-col>
    </d-row>
    <d-row
      no-gutters
      style="padding-bottom: 0 !important;"
      class="page-header py-4 mt-4">
      <d-col
        v-if="visible_weighting"
        col
        sm="12"
        class="text-center text-sm-left">
        <h3 class="page-title">Ważenie:</h3>
        <div
          class="dashboard-weighting"
          v-for="(weightings, index) in statsData.weightings"
          :key="index">
          <p class="mt-4">Ważenie dostawy z dnia: <span>{{weightings.date}}</span></p>
          <d-button
            theme="primary"
            class="text-nowrap"
            :disabled="export_file_one === true"
            @click.prevent="exportFileDoc(0, weightings.date)">
            <template v-if="export_file_one === false">
              Pobierz plik
              <i
                class="material-icons"
                style="transform: rotate(180deg); margin-left: 0.2rem">
                keyboard_capslock
              </i>
            </template>
            <template v-else>
              <div
                class="spinner-border spinner-border-sm"
                role="status"></div>
            </template>
          </d-button>
          <d-button
            theme="secondary"
            outline
            class="ml-2"
            @click.prevent="openModalFile">
            Wgraj plik
            <i
              class="material-icons"
              style="transform: rotate(360deg); margin-left: 0.2rem">keyboard_capslock</i>
          </d-button>
          <d-dropdown
            v-if="weightings.is_completed_weighting"
            theme="success"
            text="PDF"
            style="min-width: 4rem"
            class="text-nowrap ml-2"
            :disabled="export_file_two === true"
            left>
            <a
              href="#"
              class="dropdown-item"
              @click.prevent="exportFilePDF(1, weightings.date)">Lista zamówień</a>
            <a
              href="#"
              class="dropdown-item"
              @click="exportDriversFilePDF(1, weightings.date)">Podsumowanie dla kierowców</a>
          </d-dropdown >
        </div>
      </d-col>
    </d-row>
    <d-row
      v-if="visible_deliveries"
      no-gutters
      style="padding-bottom: 0 !important;"
      class="page-header py-4 mt-4">
      <d-col
        v-if="visible_deliveries"
        col
        sm="12"
        class="text-center text-sm-left">
        <h3 class="page-title">Dostawy:</h3>
        <dashboard-collapse
          :key="modal_collapse_key"
          :supplies="statsData.deliveries"
          :refresh="refresh"/>
      </d-col>
    </d-row>
    <dashboard-customers
      :key="modal_customers_list_key"
      :close-modal="closeModalCustomersList"
      :refresh="refreshData"
      :show-modal="show_modal_customers_list"/>
    <dashboard-orders
      :key="'orders-' + modal_list_key"
      :remove="true"
      :close-modal="closeModalList"
      :date="date"
      :orders="orders"
      :show-modal="show_modal_list"
      :refresh="refreshData"/>
    <dashboard-orders
      :remove="false"
      :key="'waiting_transfer-' + modal_list_waiting_transfer_key"
      :close-modal="closeModalListWaitingTransfer"
      :orders="orders_waiting_transfer"
      :show-modal="show_modal_list_waiting_transfer"
      :refresh="refreshData"/>
    <order-file
      :key="'file-' + modal_file_key"
      :close-modal="closeModalFile"
      :show-modal="show_modal_file"
      :refresh="statsDashboardGet"/>
  </d-container>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import api from '@/api';
import OrderFile from '@/views/Orders/OrdersFile';
import OrdersCollapse from '@/views/Orders/OrdersCollapse';
import DashboardCollapse from '@/views/Dashboard/DashboardCollapse';
import DashboardOrders from '@/views/Dashboard/DashboardOrders';
import ListUtils from '../../utils/ListUtils';
import DashboardCustomers from './DashboardCustomers';

export default {
  name: 'dashboard',
  components: {
    DashboardCustomers,
    DashboardOrders,
    DashboardCollapse,
    OrdersCollapse,
    OrderFile
  },
  data () {
    return {
      statsData: {},
      supplies: [],
      orders: [],
      orders_waiting_transfer: [],
      data: {},
      customers: [],
      date: '',
      loaded: false,
      export_file_one: false,
      export_file_two: false,
      show_modal_file: false,
      show_modal_list: false,
      modal_file_key: 0,
      modal_list_key: 0,
      modal_collapse_key: 0,
      modal_orders_type: '',
      downloading: '',
      download: false,
      visible_deliveries: false,
      visible_weighting: false,
      show_modal_customers_list: false,
      show_modal_list_waiting_transfer: false,
      modal_customers_list_key: 0,
      modal_list_waiting_transfer_key: 0,
    };
  },
  watch: {
    statsData (value) {
      if (value.deliveries) {
        if (value.deliveries.length) {
          this.visible_deliveries = true;
        } else {
          this.visible_deliveries = false;
        }
      }
      if (value.weightings) {
        if (value.weightings.length) {
          this.visible_weighting = true;
        } else {
          this.visible_weighting = false;
        }
      }
    },
  },
  mounted () {
    this.statsDashboardGet();
    this.loadCustomers();
    this.loadFilteredDataWaitingTransfer();
  },
  methods: {
    openModalFile () {
      this.show_modal_file = true;
    },
    refreshData () {
      this.statsDashboardGet();
      this.loadFilteredDataWaitingTransfer();

      if (this.modal_orders_type) {
        this.loadFilteredData(this.modal_orders_type);
      }

      this.modal_customers_list_key += 1;
      this.modal_collapse_key += 1;
      this.modal_list_key += 1;
    },
    refresh () {
      this.statsDashboardGet();
      this.loadFilteredDataWaitingTransfer();
    },
    closeModalFile () {
      this.show_modal_file = false;
      this.modal_file_key += 1;
    },
    openModalList (date) {
      this.modal_orders_type = date;
      this.loadFilteredData(date);
    },
    closeModalList () {
      this.show_modal_list = false;
      this.modal_list_key += 1;
    },
    openModalListWaitingTransfer () {
      this.loadFilteredDataWaitingTransfer();
      setTimeout(() => {
        this.show_modal_list_waiting_transfer = true;
      }, 500);
    },
    closeModalListWaitingTransfer () {
      this.show_modal_list_waiting_transfer = false;
      this.modal_list_waiting_transfer_key += 1;
    },
    openModalCustomersList () {
      this.loadCustomers();
      this.show_modal_customers_list = true;
    },
    closeModalCustomersList () {
      this.show_modal_customers_list = false;
      this.modal_customers_list_key += 1;
    },
    statsDashboardGet () {
      this.$http.post('/dashboard/stats', {
      }).then(response => {
        this.data = response.data;
        this.statsData = response.data.stats;
      }).catch(error => {
        console.error(error);
      });
    },
    loadFilteredData (date) {
      let where = {
        delivery_date: date,
      };
      this.$http.post('/orders/items', {
        pagination: false,
        where
      }).then(response => {
        this.orders = response.data;
        this.show_modal_list = true;
        this.date = date;
      }).catch(error => {
        console.error(error);
      });
    },
    loadFilteredDataWaitingTransfer () {
      let where = {
        waiting_transfer: 1,
      };
      this.$http.post('/orders/items', {
        pagination: false,
        where
      }).then(response => {
        this.orders_waiting_transfer = response.data;
      }).catch(error => {
        console.error(error);
      });
    },
    exportFileDoc (index, date) {
      if (index === 0) {
        this.export_file_one = true;
        this.export_file_two = false;
      }
      if (index === 1) {
        this.export_file_two = true;
        this.export_file_one = false;
      }
      let filename = 'Wazenie-';
      axios({
        url: `${api}orders/export-excel`,
        method: 'GET',
        params: {
          delivery_date: date
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + date + '.xlsx');
        document.body.appendChild(link);
        link.click();
        this.export_file_one = false;
        this.export_file_two = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
      });
    },
    loadCustomers () {
      let where = {
        orders_in_dept: 1
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/customers/items',
        listField: 'customers',
        pagination: false,
        params: {
          where
        }
      });
    },
    exportFilePDF (index, date) {
      if (index === 0) {
        this.export_file_one = true;
      }
      if (index === 1) {
        this.export_file_two = true;
      }
      let filename = 'document-';
      axios({
        url: `${api}orders/export-pdf`,
        method: 'GET',
        params: {
          delivery_date: date
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + date + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.export_file_one = false;
        this.export_file_two = false;
      });
      setTimeout(() => {
        this.export_file_one = false;
        this.export_file_two = false;
        this.statsDashboardGet();
      }, 2000);
    },
    exportDriversFilePDF (index, date) {
      if (index === 0) {
        this.export_file_one = true;
      }
      if (index === 1) {
        this.export_file_two = true;
      }
      let filename = 'suppliers-';
      axios({
        url: `${api}orders/suppliers-pdf`,
        method: 'GET',
        params: {
          delivery_date: date
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + date + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.export_file_one = false;
        this.export_file_two = false;
      });
      setTimeout(() => {
        this.export_file_one = false;
        this.export_file_two = false;
        this.statsDashboardGet();
      }, 2000);
    },
  },
};
</script>
<style lang="scss">
@import '../../assets/scss/dashboard';
</style>
